import avatar from '../assets/images/avatar.webp';
import avatarTwo from '../assets/images/avatar-ath-academy.webp';

export const slugify = (name) =>
    String(name || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

export const mapApiGraduate = (g) => ({
    id: `api-${g.id}`,
    slug: g.slug,
    name: g.name,
    title: g.professional_title || g.programme || '',
    programme: g.programme || '',
    description: g.bio || '',
    image: g.photo_url || avatar,
    fallbackImage: avatar,
    skills: Array.isArray(g.skills) ? g.skills : [],
    location: g.location || 'Abia, Nigeria',
    experience: g.academic_status || 'Recent Graduate',
    availability: g.is_available ? 'Available' : 'Unavailable',
    verified: Boolean(g.is_verified),
    githubUrl: g.github_url || null,
    graduatedAt: g.graduated_at || g.graduation_date || null,
    source: 'api',
    profilePath: `/graduates/${g.slug}`,
});

export const mapStaticTalent = (t) => ({
    ...t,
    slug: t.slug || slugify(t.name),
    programme: t.programme || t.title,
    githubUrl: t.githubUrl || null,
    source: 'static',
    profilePath: `/graduates/${t.slug || slugify(t.name)}`,
    fallbackImage: t.fallbackImage || avatarTwo,
});

export const mergeTalents = (staticTalents, apiGraduates) => {
    const staticList = staticTalents.map(mapStaticTalent);
    const staticSlugs = new Set(staticList.map((t) => t.slug));
    const staticNames = new Set(staticList.map((t) => t.name.toLowerCase()));

    const fromApi = (apiGraduates || [])
        .map(mapApiGraduate)
        .filter((g) => !staticSlugs.has(g.slug) && !staticNames.has(g.name.toLowerCase()));

    return [...staticList, ...fromApi];
};

export const findTalentBySlug = (slug, staticTalents) => {
    const normalized = String(slug || '').toLowerCase();
    return staticTalents.find(
        (t) => (t.slug || slugify(t.name)).toLowerCase() === normalized
    ) || null;
};
